import { api } from "./http";

export const genTaskApi = {
  generate: (data) => api.post("/api/GenerateTask/generate", data),
  table: (data) => api.post("/api/GenerateTask/task",data),
  taskDetail: (taskId) => api.get(`/api/GenerateTask/task-detail?taskIdPram=${taskId}`),
  submit: (param) => api.post("/api/Submission/submit", param),
  getSubmit : (id) => api.get(`/api/Submission/attempts/lastest/${id}`),
  getAttemptHistory: (id) => api.get(`/api/Submission/attempts/history/${id}`),
  getSubmitByAttempt: (attemptId) => api.get(`/api/Submission/attempts/by-attempt/${attemptId}`),
};
